import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import IForkLiftWrapper from "@components/layouts/iForkLiftWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <IForkLiftWrapper>
            <TermsAndConditions category="Forklifts" domain="iForklift.com" />
        </IForkLiftWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
